import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { dispatchEventBus, listenEvent } from '../../util';
import storageHelper from '@/modules/@orgmap/util/storage-helper'

@Component({
    name: 'tree-view-item'
})
export default class TreeViewItem  extends Vue {
    @Prop({ type: String }) treeid!: string;
    @Prop({ type: Object }) item!: treeView.TreeViewItem<any>;

    mHasChildren: boolean = false;
    mExpanded: boolean = false;
    mChilds: treeView.TreeViewItem<any>[] = [];
    mCurrent: boolean = false;
    currentId = storageHelper.get("currentId");

    @Watch('item')
    onItemChanged(newVal: treeView.TreeViewItem<any>) {
        this.mHasChildren = newVal.childs != null && newVal.childs.length > 0;
        this.mCurrent = newVal.current || false;
        this.mExpanded = newVal.expanded || newVal.current || false;        
        this.mChilds = newVal.childs || [];   
        
        if(this.mCurrent) {
            this.$nextTick(() => {
                this.onNodeNameClick();
            });
        }
    }

    created() {
        listenEvent(window, this.treeid, this.onTreeItemSelected)
        this.onItemChanged(this.item);    
    }

    onExpandClick() {
        this.mExpanded = !this.mExpanded;
    }

    onNodeNameClick() {
        storageHelper.set(this.item.id, "currentId")
        this.mCurrent = true;
        dispatchEventBus(window, this.treeid, this.item);       
    }  

    onTreeItemSelected(data: any) {
        let selectedNode = data as treeView.TreeViewItem<any>;

        if(this.item.id !== selectedNode.id) {
            this.mCurrent = false;
        }
    }   
}